import React from "react";
export function LanguageElement(_a) {
    var language = _a.language, isSelected = _a.isSelected, languageName = _a.languageName, onClick = _a.onClick;
    return (React.createElement("li", { className: "".concat(language, " ").concat(isSelected ? 'selected' : ''), onClick: onClick },
        ' ',
        React.createElement("i", { className: 'flagSelected' }),
        " ",
        React.createElement("span", { className: 'flagTxt' }, languageName),
        ' '));
}
